import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { BrandTile } from "../components/Brand";
import VoucherCard from "../components/VoucherCard";

export default function BrandPage() {
    const { slug } = useParams();
    const [data, setData] = useState(null);
    const [err, setErr] = useState("");

    useEffect(() => {
        api.get(`/api/brands/${slug}`)
            .then((r) => setData(r.data))
            .catch(() => setErr("Brand not found"));
    }, [slug]);

    if (err) return <div className="p-10 text-center text-[#6b7280]">{err}</div>;
    if (!data) return <div className="p-10 text-center text-[#6b7280]">Loading…</div>;

    const { brand, rewards } = data;

    return (
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6">
            <div className="flex items-center gap-2 text-xs text-[#6b7280] mb-3">
                <Link to="/" className="hover:text-[#0b1437]">Home</Link>
                <span>/</span>
                <Link to={`/category/${encodeURIComponent(brand.category)}`} className="hover:text-[#0b1437]">
                    {brand.category}
                </Link>
                <span>/</span>
                <span className="text-[#0b1437] font-semibold">{brand.name}</span>
            </div>

            <div className="fx-card p-6 md:p-8 flex flex-col md:flex-row items-start gap-5 overflow-hidden">
                <div className="w-24 h-24 rounded-2xl overflow-hidden shrink-0">
                    <BrandTile url={brand.logo_url} name={brand.name} />
                </div>
                <div className="flex-1">
                    <h1 className="font-display text-3xl md:text-4xl font-bold">{brand.name}</h1>
                    <p className="text-sm text-[#6b7280] mt-1">{brand.category}</p>
                    <p className="text-[#4b5563] mt-3 max-w-2xl text-sm">{brand.description || `Shop premium ${brand.category.toLowerCase()} with ${brand.name} on Fundlexperiences. Pay with points + cash for instant savings.`}</p>
                </div>
            </div>

            <h2 className="font-display text-xl font-semibold mt-8 mb-3">Available vouchers</h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
                {rewards.map((r) => <VoucherCard key={r.id} r={r} />)}
                {rewards.length === 0 && (
                    <div className="col-span-full fx-card p-8 text-center text-[#6b7280]">
                        No vouchers live for this brand right now.
                    </div>
                )}
            </div>
        </div>
    );
}
